var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8.9 14.3",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HAN-iconen-rood_cmyk-Chevron_3_",
    transform: "translate(82.414 115.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outline_3_",
    transform: "translate(-88.707 -100.146) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477_3_",
    fill: "#FFFFFF",
    d: "M1.1,8.1l1.8-1.8l5.4,5.4l5.4-5.4l1.8,1.8l-7.2,7.2L1.1,8.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/icon_chevron_right.d24db7da33c4991130fc4b175dd922cf.svg";
export { ForwardRef as ReactComponent };